"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
var assert = function (options, requiredKeys) {
    requiredKeys.forEach(function (key) {
        if (!options[key]) {
            throw new TypeError("Required \"" + key + "\" not defined");
        }
    });
};
exports.assert = assert;
//# sourceMappingURL=assert.js.map